export const DEFAULT_LIMIT = 1000;
export const EMAIL_EXTRACTION_LIMIT = 10000000;
export const CONTENT_ENCODING = 'gzip';

export const DEFAULT_FILE_FORMAT = 'text/csv';

export const FILE_FORMATS_OPTIONS = [
  { id: 'text/csv', label: 'CSV', value: 'text/csv' },
  { id: 'application/json', label: 'JSON', value: 'application/json' },
];
